import React, { Fragment } from "react";

import Crumbs from "./Crumbs";
import Search from "./Search";
import APIMaintenance from "../APIMaintenance";

const Header = () => {
  return (
    <div className="Card-header">
      <h3 className="Card-title f-h3 c-white">Quick eligibility checker</h3>
      <Crumbs static />
    </div>
  );
};

const InBillboard = ({
  maintenance,
  maintenanceMessageLine1,
  maintenanceMessageLine2,
}) => {
  return (
    <div className="Card Card--wizard">
      <Header />
      <div className="Card-inner bg-violet-light-50">
        <div className="Card-inner-content">
          {!maintenance && <Search inBillboard />}
          {maintenance && (
            <APIMaintenance
              line1={maintenanceMessageLine1}
              line2={maintenanceMessageLine2}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default InBillboard;
